import { render, staticRenderFns } from "./certificados.vue?vue&type=template&id=e6ee015a&scoped=true&lang=html&"
import script from "./certificados.vue?vue&type=script&lang=js&"
export * from "./certificados.vue?vue&type=script&lang=js&"
import style0 from "./certificados.vue?vue&type=style&index=0&id=e6ee015a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ee015a",
  null
  
)

export default component.exports